export default __webpack_public_path__ + "static/media/sold_listing.31b2bb83.png";